import { BaseService } from "@/api/services/baseService";
import request from "@/api";
import type { Person, PersonVo } from "@zhihaoscm/entity";
import { confirmable } from "@/utils/decorator/confirmable";
import type { PersonListParam, TreePerson } from "@/entity/person";

export class PersonService extends BaseService<Person, PersonVo, PersonListParam, any> {
    public async getPersonMobileById(id: number | string) {
        const { data } = await this.service.get(`${this.path}/mobile/${id}`);
        return data;
    }
    public async getPersonMailById(id: number | string) {
        const { data } = await this.service.get(`${this.path}/mail/${id}`);
        return data;
    }
    public async get(id: number | string) {
        const { data } = await this.service.get(`${this.path}/vo/${id}`);
        return data;
    }
    public async getPersonTree(): Promise<TreePerson> {
        const { data } = await this.service.get(`${this.path}/tree`);
        return data;
    }
    @confirmable("是否删除此员工")
    public async delete(id: number | string) {
        const { data } = await this.service.delete(`${this.path}/${id}`);
        return data;
    }
}

export const personService = new PersonService("/admin/person", request.service);
